import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changeDrawer, setDisturbMode } from "Store/appStore/action";
import platform from "Pub/js/platform";
let { base } = platform;
import Ajax from "Pub/js/ajax";
import { langCheck, getAvatarName } from "Pub/js/utils";
import { getStore } from "Pub/js/storageUtils";
import AvatarImg from "Components/AvatarImg";
const { NCTooltip } = base;
/**
 * 用户头像按钮
 */
class UserAvatarBtn extends React.Component {
    constructor(props) {
        super(props);
    }
    // 回写勿扰模式设置信息
    setDisturbInfo = () => {
        // 获取勿扰模式信息
        Ajax({
            url: "/nccloud/platform/appregister/querydistrub.do",
            data: {},
            info: {
                name: langCheck("0000PUB-000333") /* 国际化处理： 勿扰模式*/,
                action: langCheck("0000PUB-000335"), /* 国际化处理： 勿扰模式查询*/
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    let Info = data.data;
                    // // 后端的接口个性化设置的颜色保存不会同步到勿扰查询里 所以要前端判断下
                    // if (getStore("nccColor") && getStore("nccColor") === "black") {
                    //     Info.isdark = true;
                    // } else {
                    //     Info.isdark = false;
                    // }
                    this.props.setDisturbMode(Info);
                }
            },
        });
    };
    render() {
        let { isOpen, avatar, changeDrawer, userName } = this.props;
        return (
            <div
                fieldid='userlogo'
                className='nc-workbench-hp'
                onClick={() => {
                    // 这里需要调用查询一次
                    this.setDisturbInfo();
                    changeDrawer(!isOpen);
                }}>
                <NCTooltip
                    placement='bottom'
                    overlay={getAvatarName(userName)}
                    trigger='hover'
                    delayShow={500}
                    delay={1}
                    mouseLeaveDelay={0}
                >
                    <AvatarImg imgUrl={avatar} className='img-avatar' />
                    {/* <span>{userName}</span> */}
                </NCTooltip>
            </div>
        );
    }
}
UserAvatarBtn.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    avatar: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    changeDrawer: PropTypes.func.isRequired,
};
export default connect(
    state => ({
        isOpen: state.appData.isOpen,
        avatar: state.appData.avatar,
        userName: state.appData.userName,
    }),
    { changeDrawer, setDisturbMode },
)(UserAvatarBtn);
